import { create } from 'zustand';
import { persist } from 'zustand/middleware';
// Orval-generated functions for profile/reception
import { getApiV1ProfileUserIdReception, postApiV1ProfileUserIdReception } from '@api/generated/visitor-api/profile/profile';
import type { ReceptionDto } from '@api/generated/visitor-api/model';

interface ReceptionState {
  selectedReceptionId: string | null;
  selectedReception: ReceptionDto | null;
  isLoading: boolean;
  setSelectedReceptionId: (id: string | null) => void;
  loadSelectedReception: (ssoId: string) => Promise<void>;
  saveSelectedReception: (ssoId: string, receptionId: string) => Promise<void>;
}

export const useReceptionStore = create<ReceptionState>()(
  persist(
    (set) => ({
      selectedReceptionId: null,
      selectedReception: null,
      isLoading: false,

      setSelectedReceptionId: (id) => set({ selectedReceptionId: id }),

      loadSelectedReception: async (ssoId: string) => {
        set({ isLoading: true });
        try {
          const reception = await getApiV1ProfileUserIdReception(ssoId) as unknown as ReceptionDto | null;
          const receptionId = reception?.id;

          if (receptionId && receptionId !== '00000000-0000-0000-0000-000000000000') {
            set({ selectedReceptionId: receptionId, selectedReception: reception });
          }
        } catch (error) {
          console.error('Failed to load selected reception:', error);
        } finally {
          set({ isLoading: false });
        }
      },

      saveSelectedReception: async (ssoId: string, receptionId: string) => {
        set({ isLoading: true });
        try {
          await postApiV1ProfileUserIdReception(ssoId, JSON.stringify(receptionId));
          // Reload the full reception to get tenantIds
          const reception = await getApiV1ProfileUserIdReception(ssoId) as unknown as ReceptionDto | null;
          set({ selectedReceptionId: receptionId, selectedReception: reception ?? null });
        } catch (error) {
          console.error('Failed to save selected reception:', error);
        } finally {
          set({ isLoading: false });
        }
      },
    }),
    {
      name: 'maja-reception-store',
      partialize: (state) => ({
        selectedReceptionId: state.selectedReceptionId,
        selectedReception: state.selectedReception,
      }),
    }
  )
);
